import useSWR from 'swr';
import { fetcher } from '@shared/fetcher';
import { ProductSchema, IProduct } from '@shared/types.ts';
import { useCartProductsStore } from '../cart/use-cart-products.store.ts';
import { useUser } from '../authorization/use-user.ts';
import { useNavigate } from 'react-router-dom';
import { useFavoriteProductsStore } from '../favorite/use-favorite-products.store.ts';

async function product(url: string): Promise<IProduct | undefined> {
  const res = await fetcher.get<{ data: IProduct }>(url).catch(() => null);
  if (!res?.data) return undefined;
  if (ProductSchema.isValidSync(res?.data.data)) {
    return res?.data.data;
  }
  return undefined;
}

export function useProduct({ productId }: { productId: number }) {
  const { data, isLoading } = useSWR(`/api/products/${productId}`, product, {
    suspense: true,
  });

  const navigate = useNavigate();

  const { isUseCache } = useUser();

  const { isProductInCart, insertProduct } = useCartProductsStore({
    isUseCache,
  });
  const favoriteStore = useFavoriteProductsStore({ isUseCache });

  const mapped = {
    image: data?.main_photo || undefined,
    title: data?.name || '',
    price: data?.price || '',
    isShowPrice: true,
    subtitle: '',
    photos: data?.photos || [],
    isSelected: isProductInCart(productId),
    description: data?.description || 'Информация о товаре',
    article: `Артикул: ${data?.sku || ''}`,
    isLoading: false,
    isFavoriteSelected: favoriteStore.isFavorite(productId),
    onPressFavorite: () => {
      if (data) favoriteStore.invertProduct(data);
    },
    onPressShare: () => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-expect-error
      if (window.Share) {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-expect-error
        window.Share.postMessage(window.location.href);
      }
    },
    onPressAction: () => {
      if (data) {
        if (isProductInCart(productId)) {
          navigate('/cart');
        } else {
          insertProduct(data);
        }
      }
    },
  };

  return {
    data: mapped,
    isLoading,
    rawData: data,
  };
}
